window.apisExactExportDetailFormatter = function(value, row) {
    let html = '';
    if (row.request) {
        html += '<div class="form-group">';
        html += "<label>"+__('Request')+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.request+"</textarea>";
        html += "</div>";
    }
    if (row.response) {
        html += '<div class="form-group">';
        html += "<label>"+__('Response')+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.response+"</textarea>";
        html += "</div>";
    }
    if (row.attachment) {
        html += '<div class="form-group">';
        html += "<label>"+__('Attachment')+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.attachment+"</textarea>";
        html += "</div>";
    }
    if (row.sales_invoice_lines) {
        html += '<div class="form-group">';
        html += "<label>"+__('Invoice Lines')+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.sales_invoice_lines+"</textarea>";
        html += "</div>";
    }
    return html;
};
